export default(teamId: string, teams: any[]) => {

  if(!teamId) return "";

  if(!teams) return "";

  return teams.find((team: any) => (team._id === teamId))?.name ?? "";

}